if (!customElements.get('sondos-weekly-selector')) {
  customElements.define('sondos-weekly-selector', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.tabs = [...this.querySelectorAll('.mkhw__tab')];
      this.panels = [...this.querySelectorAll('.mkhw__row')];
      if (!this.tabs.length || this.tabs.length !== this.panels.length) return;
      this.ready = true;
      this.querySelector('.mkhw__tabs').setAttribute('role', 'tablist');
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', this.panels[i].id);
        this.panels[i].setAttribute('role', 'tabpanel');
        this.panels[i].setAttribute('aria-labelledby', tab.id);
        tab.addEventListener('click', event => {
          event.preventDefault();
          this.select(i, true);
        });
        tab.addEventListener('keydown', event => {
          let next = i;
          if (event.key === 'ArrowLeft') next = (i + 1) % this.tabs.length;
          else if (event.key === 'ArrowRight') next = (i - 1 + this.tabs.length) % this.tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = this.tabs.length - 1;
          else if (event.key === ' ') { event.preventDefault(); this.select(i, true); return; }
          else return;
          event.preventDefault();
          this.select(next, true);
          this.tabs[next].focus({ preventScroll: true });
        });
      });
      this.select(0);
      this.list = this.querySelector('.mkhw__list');
      this.settle();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => this.settle());
      addEventListener('resize', () => {
        clearTimeout(this.settleTimer);
        this.settleTimer = setTimeout(() => this.settle(), 120);
      }, { passive: true });
    }
    // The tallest panel sets the band's height, so the sections below stay put
    // when the product changes. The reason cards run 2 or 3 lines per product,
    // which moved everything under the band by ~26px per switch on desktop.
    // Hidden panels are measured in one synchronous pass, off-flow and
    // invisible; nothing paints and lazy images are not triggered.
    settle() {
      const list = this.list;
      if (!list) return;
      // The band's stylesheet is deferred (media="print" swapped to all on
      // load). Measuring before it applies pins the unstyled, stacked height
      // (694px at 768 instead of 415px), so wait until the list carries the
      // sheet's position: relative. Up to 6s, then give up quietly.
      if (getComputedStyle(list).position !== 'relative') {
        this.settleTries = (this.settleTries || 0) + 1;
        if (this.settleTries < 60) setTimeout(() => this.settle(), 100);
        return;
      }
      list.style.minHeight = '';
      const hidden = this.panels.filter(panel => panel.hidden);
      hidden.forEach(panel => { panel.hidden = false; panel.classList.add('mkhw__row--measure'); });
      const tallest = Math.max(...this.panels.map(panel => panel.offsetHeight));
      hidden.forEach(panel => { panel.classList.remove('mkhw__row--measure'); panel.hidden = true; });
      if (tallest > 0) list.style.minHeight = tallest + 'px';
    }
    select(index, reveal = false) {
      this.tabs.forEach((tab, i) => {
        tab.setAttribute('aria-selected', String(i === index));
        tab.tabIndex = i === index ? 0 : -1;
        this.panels[i].hidden = i !== index;
      });
      if (reveal) {
        const rail = this.querySelector('.mkhw__tabs');
        const outer = rail.getBoundingClientRect();
        const selected = this.tabs[index].getBoundingClientRect();
        rail.scrollBy({
          left: selected.left + selected.width / 2 - outer.left - outer.width / 2,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      }
    }
  });
}
